import { createContext } from 'react';

export type UpdateInveriteCtx = {
  showUpdateSuccessAlert: boolean;
  showUpdateErrorAlert: boolean;
  UpdateError: string;
};

const UpdateInverite = createContext<UpdateInveriteCtx>({
  showUpdateSuccessAlert: false,
  showUpdateErrorAlert: false,
  UpdateError: '',
});

export default UpdateInverite;
